import { Card } from "@/components/ui/card";
import { useIsMobile } from "@/hooks/use-mobile";
import { Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const performanceData = [
  { day: "Mon", orders: 24, revenue: 2400 },
  { day: "Tue", orders: 13, revenue: 1398 },
  { day: "Wed", orders: 98, revenue: 9800 },
  { day: "Thu", orders: 39, revenue: 3908 },
  { day: "Fri", orders: 48, revenue: 4800 },
  { day: "Sat", orders: 38, revenue: 3800 },
  { day: "Sun", orders: 43, revenue: 4300 },
];

const PerformanceAnalytics = () => {
  const isMobile = useIsMobile();

  return (
    <div className="space-y-6">
      <h1 className="text-2xl md:text-3xl font-bold">Performance Analytics</h1>
      
      <div className="grid gap-6">
        <Card className="p-4 md:p-6">
          <h2 className="text-lg font-semibold mb-4">Weekly Performance</h2>
          <div className="h-[400px]">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={performanceData}>
                <XAxis 
                  dataKey="day" 
                  tick={{ fontSize: isMobile ? 10 : 12 }}
                />
                <YAxis 
                  tick={{ fontSize: isMobile ? 10 : 12 }}
                  width={isMobile ? 30 : 40}
                />
                <Tooltip />
                <Line 
                  type="monotone" 
                  dataKey="orders" 
                  stroke="#2563eb" 
                  name="Orders"
                />
                <Line 
                  type="monotone" 
                  dataKey="revenue" 
                  stroke="#16a34a" 
                  name="Revenue"
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default PerformanceAnalytics;